<template>
  <el-cascader ref="cascader" v-model="value" :options="options" filterable :show-all-levels="showAllLevels" :props="props" @visible-change="visibleChange" @change="change" :placeholder="placeholder" :style="css" :key="isResourceShow" clearable>
  </el-cascader>
</template>

<script>
import { getCategoryList } from "@/api/category";
export default {
  name: "CategoryCas",
  props: {
    css: {
      type: Object,
      default: () => {
        return { width: "85%" };
      }
    },
    props: {
      type: Object,
      default: () => {
        return { expandTrigger: "hover",checkStrictly :true };
      }
    },
    showAllLevels:{
      type: Boolean,
      default: true
    },
    deep: {
      type: Number,
      default: 0
    },
    fArray: {
      type: Array,
      default: () => {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: "请选择商品分类"
    }
  },
  data() {
    return {
      value: "",
      options: [],
      currentValue: "",
      isResourceShow: 0
    };
  },
  methods: {
    // 获取分类
    getCategory(params) {
      getCategoryList({ ...params }).then(d => {
        let data = d.data;
        data.forEach(item => {
          item.value = item.id;
          item.label = item.name;
          item.disabled = ''
        });
        ++this.isResourceShow;
        this.options = this.formatTree(data, this.fArray, this.deep);
      });

    },
    change(value) {
      this.$emit("getCategory", value);
    },
    reset() {
      this.value = "";
      this.currentValue = "";
      ++this.isResourceShow;
      this.options = [];
      this.$refs.cascader.handleClear();
    },
    visibleChange(){  //下拉框出现/隐藏时触发
      this.$nextTick(() => {  //解决反复手动删除和搜索出现页面卡死的情况
        // 添加这段代码
        const $el = document.querySelectorAll('.el-cascader-panel .el-cascader-node[aria-owns]');
        Array.from($el).map((item) => item.removeAttribute('aria-owns'));
      });
    },
    changeVal(id, name) {
      this.$emit("getCategory", id);
      this.currentValue = name;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/CategorySelect/index.vue